import React from 'react';
import PropTypes from 'prop-types';
import { DriveStatusChart } from '../../CommonCharts/DriveStatus';

const DriveStatusComponent = ({
    model: {
        selectedTrendsData: {
            data,
            loadingStatus,
            zoom: { isZoomed },
            chartID
        }
    },
    title,
    conditionStatus,
    assetDetails,
    actions
}) => {
    return (
        <DriveStatusChart
            trendDataLoadingStatus={loadingStatus}
            selectedTrendsData={data}
            isZoomed={isZoomed}
            chartKey={chartID}
            title={title}
            conditionStatus={conditionStatus}
            assetDetails={assetDetails}
            actions={actions}
        />
    );
};
DriveStatusComponent.propTypes = {
    model: PropTypes.shape({
        selectedTrendsData: PropTypes.shape({
            loadingStatus: PropTypes.string,
            data: PropTypes.array,
            zoom: PropTypes.shape({
                isZoomed: PropTypes.bool,
            }),
            chartID: PropTypes.string
        })
    }),
    title: PropTypes.string,
    conditionStatus: PropTypes.number,
    assetDetails: PropTypes.object
};
export default DriveStatusComponent;


